<template>
  <el-drawer
    custom-class="device-info-view"
    :visible.sync="showDevice"
    :append-to-body="true"
    direction="btt"
    width="420px"
    height="auto"
    title="设备信息"
  >
    <div class="service-wrapper">
      <div class=" ">
        <el-form class="m-t">
          <el-form-item label="账号">
            {{ userName }}
          </el-form-item>
          <el-form-item label="设备名称">
            {{ deviceVersion }}
          </el-form-item>
          <el-form-item label="系统环境">
            {{ (deviceInfo.os() || "").toUpperCase() }}
          </el-form-item>
          <el-form-item label="系统版本">
            {{ osVersion.sysVersion }}
          </el-form-item>
          <el-form-item label="浏览器">
            {{ deviceInfo.userAgent() || "无" }}
          </el-form-item>
          <el-form-item label="登录端口">
            {{ productionName }}
          </el-form-item>
          <el-form-item label="当前时间">
            {{ curDate }}
          </el-form-item>
          <el-form-item label="来源">
            {{ fromDevice }}
          </el-form-item>
        </el-form>
        <el-button
          type="primary"
          v-clipboard:copy="message"
          v-clipboard:success="onCopy"
          v-clipboard:error="onError"
          >复制</el-button
        >
      </div>
    </div>
  </el-drawer>
</template>

<script>
import { Message } from "element-ui";
import { getProductionName, getOsVersion } from "utils/env";
import { getDeviceInfo } from "src/app/customer/service";

export default {
  name: "device-info",
  props: {
    isShowDeviceInfo: {
      type: Boolean,
      default: false
    }
  },
  created() {
    this.getData();
  },
  data() {
    return {
      showDevice: false,
      curDate: "",
      productionName: getProductionName()
    };
  },
  watch: {
    isShowDeviceInfo(val) {
      this.showDevice = val;
      this.curDate = moment().format("YYYY-MM-DD HH:mm:ss");
    },
    showDevice(open) {
      if (!open) {
        this.$emit("closeDeviceDialog");
      }
    }
  },
  computed: {
    ...mapState({
      state: state => state,
      userName: state => state.userName,
      deviceInfo: state => state.deviceInfo,
      isEmbedded: state => state.urlData.isEmbedded
    }),
    message() {
      const {
        userName,
        deviceVersion,
        osVersion,
        deviceInfo,
        productionName,
        curDate,
        fromDevice
      } = this;
      const os = deviceInfo.os();
      const userAgent = deviceInfo.userAgent() || "-";

      return (
        `账号：${userName}\n设备名称：${deviceVersion}\n系统环境：${os}\n系统版本：${osVersion.sysVersion}\n` +
        `浏览器：${userAgent}\n登录端口：${productionName}\n当前时间：${curDate}\n来源：${fromDevice}`
      );
    },
    // 手机系统版本
    osVersion() {
      return getOsVersion();
    },
    //来源
    fromDevice() {
      console.log(this.isEmbedded, "isEmbedded");
      const isFromApp = this.isEmbedded === 1;
      return isFromApp ? "APP进入" : "网页进入";
    },
    // 手机 名称 型号
    deviceVersion() {
      const device_type = navigator.userAgent; //获取userAgent信息
      let os =
        this.deviceInfo.mobile() ||
        this.deviceInfo.phone() ||
        this.deviceInfo.tablet();
      let model = "";
      if (os == "AndroidOS") {
        //Android系统的处理
        os = os + this.deviceInfo.version("Android");
        const str = device_type.split(";");
        const i = str.indexOf("Build/");
        if (i > -1) {
          model = str[i].substring(0, str[i].indexOf("Build/"));
        }
      }

      return os || model;
    }
  },
  methods: {
    onCopy() {
      Message.success("复制成功！");
    },
    onError() {
      Message.error("复制失败！");
    },
    async getData() {
      const { data: userDeviceInfo } = await getDeviceInfo({
        userId: this.state.userId,
        userName: this.userName,
        serverId: this.state.serverId
      });
      console.log(userDeviceInfo, "======");
    },
    close() {
      this.$emit("closeDeviceDialog");
    }
  },
  beforeDestroy() {
    this.$store.commit("setState", { queueconntFresh: true });
  }
};
</script>
<style lang="less">
.device-info-view {
  height: auto !important;

  .service-wrapper {
    padding: 15px;
    .el-form-item {
      border-bottom: 1px solid #f2f2f2;
      margin-bottom: 10px;

      .el-form-item__content {
        text-align: right;
      }
    }
  }

  .el-drawer__header {
    span {
      text-align: center;
      padding-left: 20px;
    }
  }

  .el-button {
    width: 100%;
  }
}
</style>
